import { render, staticRenderFns } from "./dangerZone.vue?vue&type=template&id=41ff227e"
import script from "./dangerZone.vue?vue&type=script&lang=js"
export * from "./dangerZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports